import React, { createContext, useState } from 'react'
import { Popup } from '../components'

type Context = any;

type Props = {
   children: any
}

export const popup_context = createContext<Context>(null)

export const UsePopUp: React.FC<Props> = ({ children }) => {
   const [pop, setPop] = useState<any>(false)

   return (
      <popup_context.Provider value={setPop}>
         {children}
         {pop && <Popup hidePopUp={() => setPop(false)} children={pop} />}
      </popup_context.Provider>
   )
}

